import { useEffect, useState } from 'react';

import type { ModelLead } from '@app/api/Leads/types';

import { getLeadsRegistryResponseTime } from '../adapters/getLeadsRegistryResponseTime';

const ONE_SECOND_MS = 1000;

export const useLeadResponseTime = (lead: ModelLead) => {
  const hasLiveTimer =
    typeof lead.AnswerTimeInMinutes !== 'number' &&
    Boolean(lead.NoAnswerSince && lead.TimeUtc);
  const [tickSeconds, setTickSeconds] = useState(0);

  useEffect(() => {
    if (!hasLiveTimer) {
      setTickSeconds(0);
      return;
    }

    const intervalId = window.setInterval(() => {
      setTickSeconds((prev) => prev + 1);
    }, ONE_SECOND_MS);

    return () => window.clearInterval(intervalId);
  }, [hasLiveTimer]);

  return getLeadsRegistryResponseTime({ lead, tickSeconds });
};
